import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ButtonSelector from '../../../common/zolaUI/ButtonSelector/ButtonSelector';

import './ChecklistAssignTaskButton.less';

const ChecklistAssignTaskButton = ({
  assignedToOwner,
  assignedToPartner,
  assignedToCurrentUser,
  ownerFirstName,
  ownerObjectId,
  partnerFirstName,
  partnerUserObjectId,
  assignToPartner,
  taskId,
  activePartner,
  handleNoPartnerClick,
  className,
  isPartnerAccount,
}) => {
  const renderButtonCopy = () => {
    const isUnassigned = activePartner && !assignedToOwner && !assignedToPartner;
    const assignToCopy = isPartnerAccount ? ownerFirstName : partnerFirstName;

    if (isUnassigned) return `Assign to ${assignToCopy}`;
    if (activePartner && assignedToCurrentUser) return 'Assigned to You';
    if (activePartner && assignedToOwner) return `Assigned to ${ownerFirstName}`;
    if (activePartner && assignedToPartner) return `Assigned to ${partnerFirstName}`;

    return 'Assign';
  };

  const handleClick = () => {
    if (!activePartner) {
      handleNoPartnerClick();
      return;
    }

    if (isPartnerAccount) {
      assignToPartner(taskId, null, ownerObjectId);
      return;
    }

    assignToPartner(taskId, partnerUserObjectId);
  };

  return (
    <div className={cx('checklist__assignPartner--container', className)}>
      <ButtonSelector
        onClick={handleClick}
        active={activePartner && (assignedToOwner || assignedToPartner)}
        className="test--buttonSelector"
      >
        <i className="zola-ui-icon zola-ui-icon-invite-partner" />
        {renderButtonCopy()}
      </ButtonSelector>
    </div>
  );
};

ChecklistAssignTaskButton.propTypes = {
  assignToPartner: PropTypes.func,
  handleNoPartnerClick: PropTypes.func,
  assignedToOwner: PropTypes.bool,
  assignedToPartner: PropTypes.bool,
  isPartnerAccount: PropTypes.bool,
  activePartner: PropTypes.bool,
  ownerFirstName: PropTypes.string,
  ownerObjectId: PropTypes.string,
  partnerFirstName: PropTypes.string,
  partnerUserObjectId: PropTypes.string,
  className: PropTypes.string,
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ChecklistAssignTaskButton.defaultProps = {
  assignedToOwner: false,
  assignedToPartner: false,
  isPartnerAccount: false,
  activePartner: false,
};

export default ChecklistAssignTaskButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistAssignTaskButton/ChecklistAssignTaskButton.jsx